import type BankDetails from '@/modules/common/hiring/models/APP/BankDetails'
import { format } from '@/utils/date.utils'

export default class CommonMapper {
  static toMiddlewareDate(date: Date | null) {
    try {
      if (!date) throw new Error('Date is required')

      const options = {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      }
      return format(date, 'en-CA', options) // yyyy-mm-dd
    } catch (error) {
      console.error(error)
      return null
    }
  }

  static fromMiddlewareDate(date: string) {
    try {
      if (!date) throw new Error('Date is required')

      // const [year, month, days] = date.split('-') // yyyy-mm-dd
      return new Date(date)
    } catch (error) {
      console.error(error)
    }
  }

  static fromDXPProductHighlights(data: any) {
    return (
      data?.map((h: any) => ({
        image: import.meta.env.VITE_API_URL_DXP_ROOT + h.imagePath,
        text: h.text
      })) ?? []
    )
  }

  static fromDXPProductPrices(data: { billingCycle: string; price: string }[]) {
    return (
      data?.reduce((acc, rate) => {
        const key = this.fromDXPProductPrice(rate.billingCycle)
        return { ...acc, [key]: rate.price }
      }, {}) ?? {}
    )
  }
  static fromDXPProductPricesTotal(data: { billingCycle: string; totalPrice: string }[]) {
    return (
      data?.reduce((acc, rate) => {
        const key = this.fromDXPProductPrice(rate.billingCycle)
        return { ...acc, [key]: rate.totalPrice }
      }, {}) ?? {}
    )
  }
  static fromDXPProductPrice(billingCycle: string) {
    const RATES: Record<string, string> = Object.freeze({
      Mensual: 'monthly',
      Bimestral: 'bimonthly',
      Trimestral: 'quarterly',
      Semestral: 'semiannual',
      Anual: 'annual',
      Unica: 'unique'
    })

    return RATES[billingCycle]
  }

  static toDXPProductPrice(billingCycle: string) {
    const RATES: Record<string, string> = Object.freeze({
      monthly: 'Mensual',
      bimonthly: 'Bimestral',
      quarterly: 'Trimestral',
      semiannual: 'Semestral',
      annual: 'Anual',
      unique: 'Unica'
    })

    return RATES[billingCycle]
  }

  static toPaymentRequest(quotationId: string, bank: BankDetails) {
    return {
      quotationId,
      paymentMeans: {
        iban: bank.iban
      }
    }
  }
}
